import {RouteRecordRaw} from "vue-router";
import LayoutView from "@/views/share/LayoutView.vue";
import HeaderView from "@/views/share/HeaderView.vue";
import {session} from "@/model/session";
import tab from "@/views/activity/tab";
import {UserAgent} from "@/model/user_agent";

export default <Array<RouteRecordRaw>>[
    {
        path: "/activities",
        meta: {auth: true},
        component: LayoutView,
        children: [
            {
                path: "",
                meta: {auth: true},
                beforeEnter: async (to, _, next) => {
                    to.meta.material = await session.material()
                    return next()
                },
                components: {
                    default: () => import(/* webpackChunkName: "activities" */ './ActivitiesPage.vue'),
                    header: HeaderView,
                },
            }
        ]
    },
    {
        path: '/activity',
        meta: {auth: true},
        component: LayoutView,
        children: [
            {
                path: ':activity_id',
                meta: {auth: true},
                beforeEnter: async (to, _, next) => {
                    const ua = to.meta.agent as UserAgent
                    for (let i = ua.meta.activities.length - 1; i >= 0; i--) {
                        if (to.params.activity_id == ua.meta.activities[i].activity_id) {
                            to.meta.activity = ua.meta.activities[i]
                        }
                    }
                    if (!to.meta.activity) next('/')
                    else return next()
                },
                components: {
                    default: () => import(/* webpackChunkName: "activity" */ './ActivityPage.vue'),
                    header: HeaderView,
                },
                children: tab
            },
        ]
    }
]
